const PENDING_PURCHASE_KEY = '@bdi_ecommerce:pending_purchase';
const PENDING_PURCHASE_MAX_AGE = 2 * 60 * 60 * 1000;

interface PendingPurchase {
  path: string;
  createdAt: number;
}

const getValidPurchasePath = (path: string): string | null => {
  try {
    const url = new URL(path, window.location.origin);
    const isSameOrigin = url.origin === window.location.origin;
    const isOrderPath = /^\/order\/[^/?#]+\/?$/.test(url.pathname);

    if (!isSameOrigin || !isOrderPath) return null;

    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return null;
  }
};

export const rememberPendingPurchase = (path: string): void => {
  const validPath = getValidPurchasePath(path);
  if (!validPath) return;

  const pendingPurchase: PendingPurchase = {
    path: validPath,
    createdAt: Date.now(),
  };

  sessionStorage.setItem(PENDING_PURCHASE_KEY, JSON.stringify(pendingPurchase));
};

export const getPendingPurchase = (): string | null => {
  const storedPurchase = sessionStorage.getItem(PENDING_PURCHASE_KEY);
  if (!storedPurchase) return null;

  try {
    const pendingPurchase = JSON.parse(storedPurchase) as PendingPurchase;
    const isExpired = Date.now() - pendingPurchase.createdAt > PENDING_PURCHASE_MAX_AGE;
    const validPath = getValidPurchasePath(pendingPurchase.path);

    if (isExpired || !validPath) {
      sessionStorage.removeItem(PENDING_PURCHASE_KEY);
      return null;
    }

    return validPath;
  } catch {
    sessionStorage.removeItem(PENDING_PURCHASE_KEY);
    return null;
  }
};

export const consumePendingPurchase = (): string | null => {
  const pendingPurchase = getPendingPurchase();

  if (pendingPurchase) {
    sessionStorage.removeItem(PENDING_PURCHASE_KEY);
  }

  return pendingPurchase;
};
